<template>

    <section class="checkout-section">

        <div class="mobile-logo">
            <a href="/">
                <img src="/images/checkout-steps/logo.jpeg">
            </a>
        </div>
        <div class="section-content">

            <div class="left-content">


                <div v-show="step == 0" class="left-details left-details1 left-details0">
                    <div class="site-logo">
                        <a href="/">
                            <img src="/images/checkout-steps/logo.jpeg">
                        </a>
                    </div>
                    <div class="breadcrumbs-list">
                        <ul>
                            <li>
                                <a href="javascript:void(0)">Cart</a>
                            </li>
                        </ul>
                    </div>


                    <div class="product-details">

                        <div class="image"><strong>Item</strong></div>
                        <div class="product-title"></div>
                        <div class="product-quantity"><strong>Quantity</strong></div>
                        <div class="price"><strong>Price</strong></div>

                    </div>



                    <div class="product-details" v-for="product in products">

                        <div class="image">
                            <img :src="product.product_image" :alt="product.info['M_TITLE']" class="shipImage"
                       :title="product.info['M_TITLE']" />
                        </div>
                        <div class="product-title">
                            <h4 v-html="product.info['M_TITLE']"></h4>
                        </div>
                        <div class="product-quantity">
                            <div class="qty-group">
                            <a href="javascript:void(0)" @click="quantityDown($event, product)"> &ndash; </a>
                            {{ product.quantity }}
                            <a href="javascript:void(0)" @click="quantityUp($event, product)"> &plus; </a>
                            </div>
                            <a href="javascript:void(0)" @click="removeItem($event, product)" class="remove"> Remove </a>
                        </div>
                        <div class="price">
                            <strong>${{ product.sale_price * product.quantity }}</strong>
                        </div>

                    </div>



                    <div class="shipping-button">
                        <a href="/" class="cart-link">
                            <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" role="img" class="_1fragem14 _1fragem30 _1fragem9e _1fragem9d" focusable="false" aria-hidden="true"><path d="M8 1 7 0 3 4 2 5l1 1 4 4 1-1-4-4"></path></svg>
                            Return to shopping
                        </a>
                        <a @click="goToStep1()" href="javascript:void(0)" class="shipping">Checkout</a>
                    </div>



                </div>







                <div v-show="step == 1 && cartItems.length == 0" class="left-details left-details1">
                    <div class="site-logo">
                        <a href="/">
                            <img src="/images/checkout-steps/logo.jpeg">
                        </a>
                    </div>


                    <div class="shipping-address">
                        <h3 style="text-align: center;">Your shopping cart is currently empty.</h3>
                        <div class="address-form">
                            <div class="input-list">

                                <div class="shipping-button">
                                    <a href="/" class="shipping" style="margin: 0 auto;">Continue Shopping</a>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>




                <div v-show="step == 1 && cartItems.length > 0" class="left-details left-details1">
                    <div class="site-logo">
                        <a href="/">
                            <img src="/images/checkout-steps/logo.jpeg">
                        </a>
                    </div>
                    <div class="breadcrumbs-list">
                        <ul>
                            <li>
                                <a href="javascript:void(0)" @click="goToStep0()">Cart</a>
                                <span class="arrow">
                                    <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" role="img" class="_1fragem14 _1fragem30 _1fragem9e _1fragem9d" focusable="false" aria-hidden="true"><path d="m2 1 1-1 4 4 1 1-1 1-4 4-1-1 4-4"></path></svg>
                                </span>
                            </li>
                            <li>
                                <a href="javascript:void(0)">Checkout</a>
                            </li>
                        </ul>
                    </div>
                    <div class="express-checkout">
                        <h2>
                            <span>Express checkout</span>
                        </h2>
                        <div class="button">
<!--
                            <a href="#" class="shop-pay">
                                <svg preserveAspectRatio="xMidYMid" viewBox="0 0 424 102" fill="inherit" xmlns="http://www.w3.org/2000/svg" role="img" class="ZSunY" title="Shop Pay" style="fill: white;"><path fill-rule="evenodd" clip-rule="evenodd" d="M204.916 30.1c3.978-4.92 10.15-8.998 17.52-8.998 16.544 0 29.576 13.696 29.565 30.595 0 17.61-13.096 30.64-28.81 30.64-8.355 0-14.75-4.277-17.087-7.845h-.222v25.864a.585.585 0 0 1-.586.589h-14.727a.598.598 0 0 1-.6-.587v-78.68c0-.16.064-.31.177-.422a.594.594 0 0 1 .423-.175h13.763a.59.59 0 0 1 .415.18c.11.11.17.26.17.418V30.1zm16.263 37.243a15.623 15.623 0 0 1-11.66-4.689 15.628 15.628 0 0 1-4.2-13.715 15.61 15.61 0 0 1 15.831-12.812 15.345 15.345 0 0 1 10.777 4.61 15.348 15.348 0 0 1 4.37 10.957 15.46 15.46 0 0 1-1.086 5.93 15.413 15.413 0 0 1-14.033 9.716z"></path><path d="M109.306 32.87c-3.402-7.136-9.852-11.746-19.57-11.746a19.486 19.486 0 0 0-15.304 7.868l-.354.432V1.454a.604.604 0 0 0-.18-.43.603.603 0 0 0-.43-.18h-13.74a.61.61 0 0 0-.599.61v80.23a.595.595 0 0 0 .596.598h14.717a.612.612 0 0 0 .61-.598v-34.21c0-6.647 4.433-11.357 11.525-11.357 7.757 0 9.718 6.383 9.718 12.888v32.68a.599.599 0 0 0 .6.597h14.683a.61.61 0 0 0 .61-.598v-34.63c0-1.185 0-2.35-.155-3.48a30.623 30.623 0 0 0-2.726-10.704zm-73.48 11.89s-7.49-1.76-10.25-2.47c-2.76-.71-7.58-2.217-7.58-5.863 0-3.646 3.89-4.81 7.833-4.81 3.944 0 8.332.954 8.675 5.33a.63.63 0 0 0 .631.575l14.505-.055a.636.636 0 0 0 .456-.198.631.631 0 0 0 .164-.467c-.898-14.008-13.187-19.017-24.523-19.017-13.44 0-23.27 8.865-23.27 18.64 0 7.136 2.016 13.83 17.873 18.483 2.782.81 6.56 1.862 9.863 2.78 3.967 1.11 6.105 2.783 6.105 5.42 0 3.06-4.43 5.186-8.786 5.186-6.305 0-10.782-2.338-11.148-6.538a.636.636 0 0 0-.632-.555l-14.472.067a.63.63 0 0 0-.632.653c.666 13.22 13.432 20.346 25.334 20.346 17.73 0 25.742-9.973 25.742-19.315.022-4.388-.987-14.384-15.89-18.196zm110.558-27.116c-13.73 0-20.578 4.666-26.074 8.4l-.167.11c-.283.195-.483.49-.56.823-.075.335-.02.687.15.984l5.43 9.355c.102.175.24.325.408.44a1.41 1.41 0 0 0 1.146.199c.192-.052.37-.146.52-.275l.433-.356c2.824-2.372 7.357-5.54 18.327-6.405 6.106-.49 11.38 1.107 15.27 4.742 4.278 3.945 6.838 10.316 6.838 17.043 0 12.378-7.292 20.157-19.005 20.312-9.653-.055-16.135-5.086-16.135-12.522 0-3.945 1.784-6.516 5.263-9.087.266-.19.454-.47.53-.788a1.356 1.356 0 0 0-.12-.94l-4.876-9.22a1.43 1.43 0 0 0-1.423-.734c-.19.025-.376.09-.54.19-5.474 3.247-12.19 9.186-11.824 20.6.443 14.528 12.522 25.62 28.224 26.075h1.863c18.66-.61 32.136-14.46 32.136-33.244 0-17.242-12.568-35.704-35.817-35.704z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M282.375 1.044h125.652c8.672 0 15.703 7.03 15.703 15.703V85.54c0 8.672-7.03 15.702-15.703 15.702H282.375c-8.672 0-15.702-7.03-15.702-15.702V16.747c0-8.673 7.03-15.703 15.702-15.703zm28.19 54.488c10.484 0 17.986-7.647 17.986-18.362 0-10.66-7.5-18.35-17.983-18.35H292.06a.827.827 0 0 0-.831.83v50.786c0 .22.09.43.245.585a.836.836 0 0 0 .584.248h6.96a.827.827 0 0 0 .829-.831V56.363a.832.832 0 0 1 .831-.831h9.885zm-.53-29c5.695 0 9.895 4.5 9.895 10.638 0 6.15-4.2 10.638-9.896 10.638h-9.352a.829.829 0 0 1-.832-.82V27.363a.844.844 0 0 1 .832-.831h9.352zM330.6 61.526a9.903 9.903 0 0 1 .988-4.757 9.86 9.86 0 0 1 3.136-3.71c2.704-2.03 6.892-3.08 13.11-3.325l6.592-.222v-1.95c0-3.89-2.615-5.54-6.815-5.54-4.197 0-6.846 1.484-7.466 3.91a.803.803 0 0 1-.798.577h-6.505a.802.802 0 0 1-.634-.277.81.81 0 0 1-.196-.664c.974-5.764 5.74-10.14 15.9-10.14 10.794 0 14.683 5.02 14.683 14.604V70.4a.792.792 0 0 1-.06.32.822.822 0 0 1-.77.523h-6.572a.842.842 0 0 1-.59-.244.845.845 0 0 1-.24-.595v-1.52a.634.634 0 0 0-.09-.38.633.633 0 0 0-.3-.25.644.644 0 0 0-.39-.02.626.626 0 0 0-.327.22c-1.962 2.137-5.153 3.69-10.24 3.69-7.457.02-12.41-3.88-12.41-10.617zm23.826-4.433V55.52l-8.532.444c-4.5.232-7.126 2.105-7.126 5.252 0 2.848 2.405 4.433 6.594 4.433 5.696 0 9.064-3.083 9.064-8.546v-.01zm14.772 23.626v5.927a.855.855 0 0 0 .609.864c1.16.317 2.357.463 3.558.434 6.37 0 12.19-2.327 15.514-11.392l14.625-39.018a.846.846 0 0 0-.113-.753.848.848 0 0 0-.675-.354H395.9a.831.831 0 0 0-.798.577l-8.056 24.71a.832.832 0 0 1-.314.4c-.143.1-.312.152-.485.152s-.34-.053-.484-.15a.886.886 0 0 1-.313-.4l-9.286-24.78a.849.849 0 0 0-.31-.39.847.847 0 0 0-.477-.152h-6.648a.844.844 0 0 0-.786 1.109L381.62 72.63a.82.82 0 0 1 0 .565l-.432 1.363a7.878 7.878 0 0 1-7.945 5.621 16.409 16.409 0 0 1-3.048-.29.847.847 0 0 0-.996.834z"></path></svg>
                            </a>
-->

                            <div id="gPayContainer"></div>

                            <button type="button" id="applePay"></button>

                            <div id="paypal-button"></div>


                        </div>
                        <h2>
                            <span>OR</span>
                        </h2>
                    </div>

                    <form>
                    <div class="contact-information">
                        <h3>Contact information</h3>
                        <input
                            type="text"
                            name="email"
                            placeholder="Email"
                            class="default-input"
                            autocomplete="email"
                            v-model="formData.email"
                            @blur="validateFieldOnFocus"
                            :class="invalidFields.email ? 'error' : ''"
                            id="email"
                        >
                        <span v-if="invalidFields.email" class="help-block form-error">Email Address is a required field</span>
<!--
                        <div class="news-checbox">
                            <div class="checkbox">
                                <input v-model="formData.email_me" type="checkbox" name="marketing_opt_in">
                            </div>
                            <label>Email me with news and offers</label>
                        </div>
-->
                    </div>


                    <div class="shipping-address">
                        <h3>Shipping address</h3>
                        <div class="address-form">
                            <div class="input-list">
                                <div class="country">
                                    <select name="countryCode" id="country" required="" class="_d9iN hxBol r7mmh B3hX4" :class="invalidFields.delcountry ? 'error' : ''" autocomplete="country-name" v-model="formData.delInf.country">
                                        <option value="226">United States</option>
                                        <option value="173">Puerto Rico</option>
                                    </select>
                                    <div class="arrow">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" role="img" class="_1fragem14 _1fragem30 _1fragem9e _1fragem9d" focusable="false" aria-hidden="true"><path d="M0 5h20L10 15"></path></svg>
                                    </div>
                                </div>
                                <div class="name-input">
                                    <div>
                                        <input
                                            v-model="formData.delInf.first_name"
                                            name="firstName"
                                            placeholder="First name"
                                            type="text"
                                            class="default-input"
                                            autocomplete="given-name"
                                            @blur="validateFieldOnFocus"
                                            :class="invalidFields.delfirstName ? 'error' : ''"
                                            id="delfirstName">
                                            <span v-if="invalidFields.delfirstName" class="help-block form-error">First Name is a required field</span>
                                    </div>
                                    <div>
                                        <input
                                            v-model="formData.delInf.last_name"
                                            name="lastName"
                                            placeholder="Last name"
                                            type="text"
                                            class="default-input"
                                            autocomplete="family-name"
                                            @blur="validateFieldOnFocus"
                                            :class="invalidFields.dellastName ? 'error' : ''"
                                            id="dellastName">
                                            <span v-if="invalidFields.dellastName" class="help-block form-error">Last Name is a required field</span>
                                    </div>

                                </div>
                                <div class="company">
                                    <input v-model="formData.delInf.company" name="company" placeholder="Company (optional)" type="text" class="default-input" autocomplete="company">
                                </div>
                                <div class="address">
                                    <input
                                        v-model="formData.delInf.add_1"
                                        name="address1"
                                        placeholder="Address"
                                        type="text"
                                        class="default-input"
                                        autocomplete="address-line1"
                                        @blur="validateFieldOnFocus"
                                        :class="invalidFields.deladd_1 ? 'error' : ''"
                                        id="deladd_1">
                                        <span v-if="invalidFields.deladd_1" class="help-block form-error">Address is a required field</span>
                                </div>
                                <div class="address">
                                    <input v-model="formData.delInf.add_2" name="address2" placeholder="Apartment, suite, etc. (optional)" type="text" class="default-input" aautocomplete="address-line2">
                                </div>
                                <div class="city-input">
                                    <div class="city">
                                        <input
                                            v-model="formData.delInf.town"
                                            name="city"
                                            placeholder="City"
                                            type="text"
                                            class="default-input"
                                            autocomplete="address-level2"
                                            @blur="validateFieldOnFocus"
                                            :class="invalidFields.deltown ? 'error' : ''"
                                            id="deltown">
                                            <span v-if="invalidFields.deltown" class="help-block form-error">City is a required field</span>
                                    </div>
                                    <div class="state">
                                        <select
                                            v-model="formData.delInf.county"
                                            name="county"
                                            autocomplete="address-level1"
                                            @blur="validateFieldOnFocus"
                                            :class="invalidFields.delcounty ? 'error' : ''"
                                            id="delcounty">
                                            <option value="">State</option>
                                            <option value="Alabama">Alabama</option>
                                            <option value="Alaska">Alaska</option>
                                            <option value="American Samoa">American Samoa</option>
                                            <option value="Arizona">Arizona</option>
                                            <option value="Arkansas">Arkansas</option>
                                            <option value="California">California</option>
                                            <option value="Colorado">Colorado</option>
                                            <option value="Connecticut">Connecticut</option>
                                            <option value="Delaware">Delaware</option>
                                            <option value="Washington DC">Washington DC</option>
                                            <option value="Micronesia">Micronesia</option>
                                            <option value="Florida">Florida</option>
                                            <option value="Georgia">Georgia</option>
                                            <option value="Guam">Guam</option>
                                            <option value="Hawaii">Hawaii</option>
                                            <option value="Idaho">Idaho</option>
                                            <option value="Illinois">Illinois</option>
                                            <option value="Indiana">Indiana</option>
                                            <option value="Iowa">Iowa</option>
                                            <option value="Kansas">Kansas</option>
                                            <option value="Kentucky">Kentucky</option>
                                            <option value="Louisiana">Louisiana</option>
                                            <option value="Maine">Maine</option>
                                            <option value="Marshall Islands">Marshall Islands</option>
                                            <option value="Maryland">Maryland</option>
                                            <option value="Massachusetts">Massachusetts</option>
                                            <option value="Michigan">Michigan</option>
                                            <option value="Minnesota">Minnesota</option>
                                            <option value="Mississippi">Mississippi</option>
                                            <option value="Missouri">Missouri</option>
                                            <option value="Montana">Montana</option>
                                            <option value="Nebraska">Nebraska</option>
                                            <option value="Nevada">Nevada</option>
                                            <option value="New Hampshire">New Hampshire</option>
                                            <option value="New Jersey">New Jersey</option>
                                            <option value="New Mexico">New Mexico</option>
                                            <option value="New York">New York</option>
                                            <option value="North Carolina">North Carolina</option>
                                            <option value="North Dakota">North Dakota</option>
                                            <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                                            <option value="Ohio">Ohio</option>
                                            <option value="Oklahoma">Oklahoma</option>
                                            <option value="Oregon">Oregon</option>
                                            <option value="Palau">Palau</option>
                                            <option value="Pennsylvania">Pennsylvania</option>
                                            <option value="Puerto Rico">Puerto Rico</option>
                                            <option value="Rhode Island">Rhode Island</option>
                                            <option value="South Carolina">South Carolina</option>
                                            <option value="South Dakota">South Dakota</option>
                                            <option value="Tennessee">Tennessee</option>
                                            <option value="Texas">Texas</option>
                                            <option value="Utah">Utah</option>
                                            <option value="Vermont">Vermont</option>
                                            <option value="Virginia">Virginia</option>
                                            <option value="Washington">Washington</option>
                                            <option value="West Virginia">West Virginia</option>
                                            <option value="Wisconsin">Wisconsin</option>
                                            <option value="Wyoming">Wyoming</option>
                                            <option value="U.S. Virgin Islands">U.S. Virgin Islands</option>
                                            <option value="Armed Forces Americas">Armed Forces Americas</option>
                                            <option value="Armed Forces Europe">Armed Forces Europe</option>
                                            <option value="Armed Forces Pacific">Armed Forces Pacific</option>
                                        </select>
                                        <div class="arrow">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" role="img" class="_1fragem14 _1fragem30 _1fragem9e _1fragem9d" focusable="false" aria-hidden="true"><path d="M0 5h20L10 15"></path></svg>
                                        </div>
                                        <span v-if="invalidFields.delcounty" class="help-block form-error">State is required</span>
                                    </div>
                                    <div class="zip-code">
                                        <input
                                            v-model="formData.delInf.postcode"
                                            name="postalCode"
                                            placeholder="ZIP code"
                                            type="text"
                                            class="default-input"
                                            autocomplete="postal-code"
                                            @blur="validateFieldOnFocus"
                                            :class="invalidFields.delpostcode ? 'error' : ''"
                                            id="delpostcode">
                                            <span v-if="invalidFields.delpostcode" class="help-block form-error">ZIP Code is a required field</span>
                                    </div>
                                </div>
                                <div class="phone">
                                    <input
                                        v-model="formData.delInf.phone"
                                        name="phone_field"
                                        placeholder="Phone"
                                        type="tel"
                                        class="default-input"
                                        autocomplete="tel"
                                        @blur="validateFieldOnFocus"
                                        :class="invalidFields.delphone ? 'error' : ''"
                                        id="delphone">
                                        <span v-if="invalidFields.delphone" class="help-block form-error">Phone is a required field</span>
                                </div>
                                <div class="shipping-button">
                                    <a @click="goToStep0()" href="javascript:void(0)" class="cart-link">
                                        <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" role="img" class="_1fragem14 _1fragem30 _1fragem9e _1fragem9d" focusable="false" aria-hidden="true"><path d="M8 1 7 0 3 4 2 5l1 1 4 4 1-1-4-4"></path></svg>
                                        Return to Cart
                                    </a>
                                    <a @click="goToStep2()" href="javascript:void(0)" class="shipping">Continue to payment</a>
                                </div>
                                <div class="policy-link">
                                    <ul>
                                        <li><a href="#">Refund policy</a></li>
                                        <li><a href="#">Privacy policy</a></li>
                                        <li><a href="#">Terms of service</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    </form>
                </div>


                <div v-show="step == 2" class="left-details left-details2">
                    <div class="site-logo">
                        <a href="/">
                            <img src="/images/checkout-steps/logo.jpeg">
                        </a>
                    </div>
                    <div class="breadcrumbs-list">
                        <ul>
                            <li>
                                <a href="javascript:void(0)" @click="goToStep0()">Cart</a>
                                <span class="arrow">
                                    <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" role="img" class="_1fragem14 _1fragem30 _1fragem9e _1fragem9d" focusable="false" aria-hidden="true"><path d="m2 1 1-1 4 4 1 1-1 1-4 4-1-1 4-4"></path></svg>
                                </span>
                            </li>
                            <li>
                                <a href="javascript:void(0)" @click="goToStep1()">Checkout</a>
                                <span class="arrow">
                                    <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" role="img" class="_1fragem14 _1fragem30 _1fragem9e _1fragem9d" focusable="false" aria-hidden="true"><path d="m2 1 1-1 4 4 1 1-1 1-4 4-1-1 4-4"></path></svg>
                                </span>
                            </li>
                            <li>
                                <a href="javascript:void(0)">Shipping</a>
                            </li>
                        </ul>
                    </div>
                    <div class="contact-details">
                        <div class="contact">
                            <h3>Contact</h3>
                            <p>{{formData.email}}</p>
                            <a @click="goToStep1()" href="javascript:void(0)">Change</a>
                        </div>
                        <div class="ship">
                            <h2>Ship to</h2>
                            <p>{{formData.delInf.add_1}} {{formData.delInf.add_2}} {{formData.delInf.town}}, {{formData.delInf.county}}, {{ countries[formData.delInf.country] }}</p>
                            <a @click="goToStep1()" href="javascript:void(0)">Change</a>
                        </div>
                    </div>
                    <div class="shipping-method">
                        <h2>Shipping method</h2>
                        <div class="standard">
                            <h3>Standard</h3>
                            <span>${{shippingPrice}}</span>
                        </div>
                    </div>
                    <div class="shipping-button">
                        <a @click="goToStep1()" href="javascript:void(0)" class="cart-link">
                            <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" role="img" class="_1fragem14 _1fragem30 _1fragem9e _1fragem9d" focusable="false" aria-hidden="true"><path d="M8 1 7 0 3 4 2 5l1 1 4 4 1-1-4-4"></path></svg>
                            Return to information
                        </a>
                        <a @click="goToStep2()" href="javascript:void(0);" class="shipping">Continue to payment2</a>
                    </div>
                    <div class="copy-right">
                        <p>All rights reserved 2011-2023 Imperial Auto Services LLC</p>
                    </div>
                </div>


          <div v-show="step == 3" class="left-details left-details3">
            <div class="site-logo">
              <a href="/">
                <img src="/images/checkout-steps/logo.jpeg" />
              </a>
            </div>
            <div class="breadcrumbs-list">
              <ul>
                <li>
                  <a href="javascript:void(0)" @click="goToStep0()">Cart</a>
                  <span class="arrow">
                    <svg
                      viewBox="0 0 10 10"
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      class="_1fragem14 _1fragem30 _1fragem9e _1fragem9d"
                      focusable="false"
                      aria-hidden="true"
                    >
                      <path d="m2 1 1-1 4 4 1 1-1 1-4 4-1-1 4-4"></path>
                    </svg>
                  </span>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="goToStep1()">Checkout</a>
                  <span class="arrow">
                    <svg
                      viewBox="0 0 10 10"
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      class="_1fragem14 _1fragem30 _1fragem9e _1fragem9d"
                      focusable="false"
                      aria-hidden="true"
                    >
                      <path d="m2 1 1-1 4 4 1 1-1 1-4 4-1-1 4-4"></path>
                    </svg>
                  </span>
                </li>
                <li>
                  <a href="javascript:void(0)">Payment</a>
                </li>
              </ul>
            </div>
            <div class="contact-details">
                <div class="contact">
                    <h3>Contact</h3>
                    <p>{{formData.email}}</p>
                    <a @click="goToStep1()" href="javascript:void(0)">Change</a>
                </div>
                <div class="ship">
                    <h2>Ship to</h2>
                    <p>{{formData.delInf.add_1}} {{formData.delInf.add_2}} {{formData.delInf.town}}, {{formData.delInf.county}}, {{ countries[formData.delInf.country] }}</p>
                    <a @click="goToStep1()" href="javascript:void(0)">Change</a>
                </div>
            </div>
            <div class="payment-details">
              <h2>Payment</h2>
              <p>All transactions are secure and encrypted.</p>
              <div class="payment-content">
                <div class="credit-card">
                  <div class="radio__input">
                    <input
                      class="input-radio"
                      type="radio"
                      checked="checked"
                      name="checkout[payment_gateway]"
                    />
                  </div>
                  <div class="radio__label">
                    <label>Credit card</label>
                    <div class="radio__label__accessory">
                      <ul>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 38 24"
                            role="img"
                            width="38"
                            height="24"
                            aria-labelledby="pi-visa"
                          >
                            <title id="pi-visa">Visa</title>
                            <path
                              opacity=".07"
                              d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
                            />
                            <path
                              fill="#fff"
                              d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
                            />
                            <path
                              d="M28.3 10.1H28c-.4 1-.7 1.5-1 3h1.9c-.3-1.5-.3-2.2-.6-3zm2.9 5.9h-1.7c-.1 0-.1 0-.2-.1l-.2-.9-.1-.2h-2.4c-.1 0-.2 0-.2.2l-.3.9c0 .1-.1.1-.1.1h-2.1l.2-.5L27 8.7c0-.5.3-.7.8-.7h1.5c.1 0 .2 0 .2.2l1.4 6.5c.1.4.2.7.2 1.1.1.1.1.1.1.2zm-13.4-.3l.4-1.8c.1 0 .2.1.2.1.7.3 1.4.5 2.1.4.2 0 .5-.1.7-.2.5-.2.5-.7.1-1.1-.2-.2-.5-.3-.8-.5-.4-.2-.8-.4-1.1-.7-1.2-1-.8-2.4-.1-3.1.6-.4.9-.8 1.7-.8 1.2 0 2.5 0 3.1.2h.1c-.1.6-.2 1.1-.4 1.7-.5-.2-1-.4-1.5-.4-.3 0-.6 0-.9.1-.2 0-.3.1-.4.2-.2.2-.2.5 0 .7l.5.4c.4.2.8.4 1.1.6.5.3 1 .8 1.1 1.4.2.9-.1 1.7-.9 2.3-.5.4-.7.6-1.4.6-1.4 0-2.5.1-3.4-.2-.1.2-.1.2-.2.1zm-3.5.3c.1-.7.1-.7.2-1 .5-2.2 1-4.5 1.4-6.7.1-.2.1-.3.3-.3H18c-.2 1.2-.4 2.1-.7 3.2-.3 1.5-.6 3-1 4.5 0 .2-.1.2-.3.2M5 8.2c0-.1.2-.2.3-.2h3.4c.5 0 .9.3 1 .8l.9 4.4c0 .1 0 .1.1.2 0-.1.1-.1.1-.1l2.1-5.1c-.1-.1 0-.2.1-.2h2.1c0 .1 0 .1-.1.2l-3.1 7.3c-.1.2-.1.3-.2.4-.1.1-.3 0-.5 0H9.7c-.1 0-.2 0-.2-.2L7.9 9.5c-.2-.2-.5-.5-.9-.6-.6-.3-1.7-.5-1.9-.5L5 8.2z"
                              fill="#142688"
                            />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 38 24"
                            role="img"
                            width="38"
                            height="24"
                            aria-labelledby="pi-master"
                          >
                            <title id="pi-master">Mastercard</title>
                            <path
                              opacity=".07"
                              d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
                            />
                            <path
                              fill="#fff"
                              d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
                            />
                            <circle fill="#EB001B" cx="15" cy="12" r="7" />
                            <circle fill="#F79E1B" cx="23" cy="12" r="7" />
                            <path
                              fill="#FF5F00"
                              d="M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z"
                            />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            viewBox="0 0 38 24"
                            width="38"
                            height="24"
                            aria-labelledby="pi-american_express"
                          >
                            <title id="pi-american_express">
                              American Express
                            </title>
                            <g fill="none">
                              <path
                                fill="#000"
                                d="M35,0 L3,0 C1.3,0 0,1.3 0,3 L0,21 C0,22.7 1.4,24 3,24 L35,24 C36.7,24 38,22.7 38,21 L38,3 C38,1.3 36.6,0 35,0 Z"
                                opacity=".07"
                              />
                              <path
                                fill="#006FCF"
                                d="M35,1 C36.1,1 37,1.9 37,3 L37,21 C37,22.1 36.1,23 35,23 L3,23 C1.9,23 1,22.1 1,21 L1,3 C1,1.9 1.9,1 3,1 L35,1"
                              />
                              <path
                                fill="#FFF"
                                d="M8.971,10.268 L9.745,12.144 L8.203,12.144 L8.971,10.268 Z M25.046,10.346 L22.069,10.346 L22.069,11.173 L24.998,11.173 L24.998,12.412 L22.075,12.412 L22.075,13.334 L25.052,13.334 L25.052,14.073 L27.129,11.828 L25.052,9.488 L25.046,10.346 L25.046,10.346 Z M10.983,8.006 L14.978,8.006 L15.865,9.941 L16.687,8 L27.057,8 L28.135,9.19 L29.25,8 L34.013,8 L30.494,11.852 L33.977,15.68 L29.143,15.68 L28.065,14.49 L26.94,15.68 L10.03,15.68 L9.536,14.49 L8.406,14.49 L7.911,15.68 L4,15.68 L7.286,8 L10.716,8 L10.983,8.006 Z M19.646,9.084 L17.407,9.084 L15.907,12.62 L14.282,9.084 L12.06,9.084 L12.06,13.894 L10,9.084 L8.007,9.084 L5.625,14.596 L7.18,14.596 L7.674,13.406 L10.27,13.406 L10.764,14.596 L13.484,14.596 L13.484,10.661 L15.235,14.602 L16.425,14.602 L18.165,10.673 L18.165,14.603 L19.623,14.603 L19.647,9.083 L19.646,9.084 Z M28.986,11.852 L31.517,9.084 L29.695,9.084 L28.094,10.81 L26.546,9.084 L20.652,9.084 L20.652,14.602 L26.462,14.602 L28.076,12.864 L29.624,14.602 L31.499,14.602 L28.987,11.852 L28.986,11.852 Z"
                              />
                            </g>
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 38 24"
                            width="38"
                            height="24"
                            role="img"
                            aria-labelledby="pi-discover"
                            fill="none"
                          >
                            <title id="pi-discover">Discover</title>
                            <path
                              fill="#000"
                              opacity=".07"
                              d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
                            />
                            <path
                              d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32z"
                              fill="#fff"
                            />
                            <path
                              d="M3.57 7.16H2v5.5h1.57c.83 0 1.43-.2 1.96-.63.63-.52 1-1.3 1-2.11-.01-1.63-1.22-2.76-2.96-2.76zm1.26 4.14c-.34.3-.77.44-1.47.44h-.29V8.1h.29c.69 0 1.11.12 1.47.44.37.33.59.84.59 1.37 0 .53-.22 1.06-.59 1.39zm2.19-4.14h1.07v5.5H7.02v-5.5zm3.69 2.11c-.64-.24-.83-.4-.83-.69 0-.35.34-.61.8-.61.32 0 .59.13.86.45l.56-.73c-.46-.4-1.01-.61-1.62-.61-.97 0-1.72.68-1.72 1.58 0 .76.35 1.15 1.35 1.51.42.15.63.25.74.31.21.14.32.34.32.57 0 .45-.35.78-.83.78-.51 0-.92-.26-1.17-.73l-.69.67c.49.73 1.09 1.05 1.9 1.05 1.11 0 1.9-.74 1.9-1.81.02-.89-.35-1.29-1.57-1.74zm1.92.65c0 1.62 1.27 2.87 2.9 2.87.46 0 .86-.09 1.34-.32v-1.26c-.43.43-.81.6-1.29.6-1.08 0-1.85-.78-1.85-1.9 0-1.06.79-1.89 1.8-1.89.51 0 .9.18 1.34.62V7.38c-.47-.24-.86-.34-1.32-.34-1.61 0-2.92 1.28-2.92 2.88zm12.76.94l-1.47-3.7h-1.17l2.33 5.64h.58l2.37-5.64h-1.16l-1.48 3.7zm3.13 1.8h3.04v-.93h-1.97v-1.48h1.9v-.93h-1.9V8.1h1.97v-.94h-3.04v5.5zm7.29-3.87c0-1.03-.71-1.62-1.95-1.62h-1.59v5.5h1.07v-2.21h.14l1.48 2.21h1.32l-1.73-2.32c.81-.17 1.26-.72 1.26-1.56zm-2.16.91h-.31V8.03h.33c.67 0 1.03.28 1.03.82 0 .55-.36.85-1.05.85z"
                              fill="#231F20"
                            />
                            <path
                              d="M20.16 12.86a2.931 2.931 0 100-5.862 2.931 2.931 0 000 5.862z"
                              fill="url(#pi-paint0_linear)"
                            />
                            <path
                              opacity=".65"
                              d="M20.16 12.86a2.931 2.931 0 100-5.862 2.931 2.931 0 000 5.862z"
                              fill="url(#pi-paint1_linear)"
                            />
                            <path
                              d="M36.57 7.506c0-.1-.07-.15-.18-.15h-.16v.48h.12v-.19l.14.19h.14l-.16-.2c.06-.01.1-.06.1-.13zm-.2.07h-.02v-.13h.02c.06 0 .09.02.09.06 0 .05-.03.07-.09.07z"
                              fill="#231F20"
                            />
                            <path
                              d="M36.41 7.176c-.23 0-.42.19-.42.42 0 .23.19.42.42.42.23 0 .42-.19.42-.42 0-.23-.19-.42-.42-.42zm0 .77c-.18 0-.34-.15-.34-.35 0-.19.15-.35.34-.35.18 0 .33.16.33.35 0 .19-.15.35-.33.35z"
                              fill="#231F20"
                            />
                            <path
                              d="M37 12.984S27.09 19.873 8.976 23h26.023a2 2 0 002-1.984l.024-3.02L37 12.985z"
                              fill="#F48120"
                            />
                            <defs>
                              <linearGradient
                                id="pi-paint0_linear"
                                x1="21.657"
                                y1="12.275"
                                x2="19.632"
                                y2="9.104"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stop-color="#F89F20" />
                                <stop offset=".25" stop-color="#F79A20" />
                                <stop offset=".533" stop-color="#F68D20" />
                                <stop offset=".62" stop-color="#F58720" />
                                <stop offset=".723" stop-color="#F48120" />
                                <stop offset="1" stop-color="#F37521" />
                              </linearGradient>
                              <linearGradient
                                id="pi-paint1_linear"
                                x1="21.338"
                                y1="12.232"
                                x2="18.378"
                                y2="6.446"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stop-color="#F58720" />
                                <stop offset=".359" stop-color="#E16F27" />
                                <stop offset=".703" stop-color="#D4602C" />
                                <stop offset=".982" stop-color="#D05B2E" />
                              </linearGradient>
                            </defs>
                          </svg>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="card-number">
                  <div class="number">
                    <input
                      autocomplete="cc-number"
                      name="number"
                      type="text"
                      pattern="[0-9]*"
                      aria-describedby="error-for-number tooltip-for-number"
                      data-current-field="number"
                      class="default-input"
                      placeholder="Card number"
                      style="
                        color: rgb(51, 51, 51);
                        font-family: -apple-system, BlinkMacSystemFont,
                          'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
                          'Apple Color Emoji', 'Segoe UI Emoji',
                          'Segoe UI Symbol', sans-serif;
                        padding: 0.94em 0.8em;
                        transition: padding 0.2s ease-out 0s;
                      "
                      v-model="formData.aim.card"
                      @blur="validateFieldOnFocus"
                      :class="invalidFields.aimCard ? 'error' : ''"
                      id="aimCard">
                      <span v-if="invalidFields.aimCard" class="help-block form-error">Card Number is a required field</span>
                  </div>
                  <div class="date">

                    <div class="expiration">
                          <select name="expirationMonth" id="expirationMonth" class="textbox "
                                  v-model="formData.aim.month">
                            <option value="">Month</option>
                            <option :value="id + 1" v-for="(name, id) in orderedMonths">{{ name }}</option>
                          </select>
                        <div class="arrow">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" role="img" class="_1fragem14 _1fragem30 _1fragem9e _1fragem9d" focusable="false" aria-hidden="true"><path d="M0 5h20L10 15"></path></svg>
                        </div>
                    </div>
                    <div class="code">
                      <select name="expirationYear" id="expirationYear" class="textbox "
                              v-model="formData.aim.year">
                        <option value="">Year</option>
                        <option :value="id" v-for="(year, id) in this.years">{{ year }}</option>
                      </select>
                        <div class="arrow">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" role="img" class="_1fragem14 _1fragem30 _1fragem9e _1fragem9d" focusable="false" aria-hidden="true"><path d="M0 5h20L10 15"></path></svg>
                        </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>
            <div class="billing-details">
              <h2>Billing address</h2>
              <p>
                Select the address that matches your card or payment method.
              </p>
              <div class="billing-radio">
                <div class="radio-button">
                  <div class="radio__input">
                    <input
                      class="input-radio"
                      type="radio"
                      checked="checked"
                      name="checkout[billing_address]"
                      v-model="billing_address"
                      value="same"
                    />
                  </div>
                  <label>Same as shipping address</label>
                </div>
                <div class="radio-button">
                  <div class="radio__input">
                    <input
                      class="input-radio"
                      type="radio"
                      name="checkout[billing_address]"
                      v-model="billing_address"
                      value="different"
                    />
                  </div>
                  <label>Use a different billing address</label>

                </div>
                                <div class="shipping-address" v-if="billing_address == 'different'">
                                    <form class="address-form">
                                        <div class="input-list">
                                            <div class="country">
                                                <select
                                                    name="countryCode"
                                                    id="delcountry"
                                                    required=""
                                                    class="_d9iN hxBol r7mmh B3hX4"
                                                    :class="invalidFields.country ? 'error' : ''"
                                                    autocomplete="country-name"
                                                    v-model="formData.country"
                                                >
                                                    <option value="226">United States</option>
                                                    <option value="173">Puerto Rico</option>
                                                </select>
                                                <div class="arrow">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 20 20"
                                                        role="img"
                                                        class="_1fragem14 _1fragem30 _1fragem9e _1fragem9d"
                                                        focusable="false"
                                                        aria-hidden="true"
                                                    >
                                                        <path d="M0 5h20L10 15"></path>
                                                    </svg>
                                                </div>
                                            </div>
                                            <div class="name-input">
                                                <div>
                                                <input
                                                    name="firstName"
                                                    placeholder="First name"
                                                    type="text"
                                                    class="default-input"
                                                    autocomplete="given-name"
                                                    v-model="formData.first_name"
                                                    @blur="validateFieldOnFocus"
                                                    :class="invalidFields.firstName ? 'error' : ''"
                                                    id="firstName">
                                                    <span v-if="invalidFields.firstName" class="help-block form-error">First Name is a required field</span>
                                                </div>
                                                <div>
                                                <input
                                                    name="lastName"
                                                    placeholder="Last name"
                                                    type="text"
                                                    class="default-input"
                                                    autocomplete="family-name"
                                                    v-model="formData.last_name"
                                                    @blur="validateFieldOnFocus"
                                                    :class="invalidFields.lastName ? 'error' : ''"
                                                    id="lastName">
                                                    <span v-if="invalidFields.lastName" class="help-block form-error">Last Name is a required field</span>
                                                </div>
                                            </div>
                                            <div class="company">
                                                <input
                                                    name="company"
                                                    placeholder="Company (optional)"
                                                    type="text"
                                                    class="default-input"
                                                    autocomplete="company"
                                                    v-model="formData.company"
                                                />
                                            </div>
                                            <div class="address">
                                                <input
                                                    name="address1"
                                                    placeholder="Address"
                                                    type="text"
                                                    class="default-input"
                                                    autocomplete="address-line1"
                                                    v-model="formData.add_1"
                                                    @blur="validateFieldOnFocus"
                                                    :class="invalidFields.add_1 ? 'error' : ''"
                                                    id="add_1">
                                                    <span v-if="invalidFields.add_1" class="help-block form-error">Address is a required field</span>
                                            </div>
                                            <div class="address">
                                                <input
                                                    name="address2"
                                                    placeholder="Apartment, suite, etc. (optional)"
                                                    type="text"
                                                    class="default-input"
                                                    autocomplete="address-line2"
                                                    v-model="formData.add_2"
                                                />
                                            </div>
                                            <div class="city-input">
                                                <div class="city">
                                                    <input
                                                        name="city"
                                                        placeholder="City"
                                                        type="text"
                                                        class="default-input"
                                                        autocomplete="address-level2"
                                                        v-model="formData.town"
                                                        @blur="validateFieldOnFocus"
                                                        :class="invalidFields.town ? 'error' : ''"
                                                        id="town">
                                                        <span v-if="invalidFields.town" class="help-block form-error">City is a required field</span>
                                                </div>
                                                <div class="state">
                                                    <select
                                                        name="zone"
                                                        v-model="formData.county"
                                                        autocomplete="address-level1"
                                                        @blur="validateFieldOnFocus"
                                                        :class="invalidFields.county ? 'error' : ''"
                                                        id="county">
                                                        <option value="">State</option>
                                                        <option value="Alabama">Alabama</option>
                                                        <option value="Alaska">Alaska</option>
                                                        <option value="American Samoa">American Samoa</option>
                                                        <option value="Arizona">Arizona</option>
                                                        <option value="Arkansas">Arkansas</option>
                                                        <option value="California">California</option>
                                                        <option value="Colorado">Colorado</option>
                                                        <option value="Connecticut">Connecticut</option>
                                                        <option value="Delaware">Delaware</option>
                                                        <option value="Washington DC">Washington DC</option>
                                                        <option value="Micronesia">Micronesia</option>
                                                        <option value="Florida">Florida</option>
                                                        <option value="Georgia">Georgia</option>
                                                        <option value="Guam">Guam</option>
                                                        <option value="Hawaii">Hawaii</option>
                                                        <option value="Idaho">Idaho</option>
                                                        <option value="Illinois">Illinois</option>
                                                        <option value="Indiana">Indiana</option>
                                                        <option value="Iowa">Iowa</option>
                                                        <option value="Kansas">Kansas</option>
                                                        <option value="Kentucky">Kentucky</option>
                                                        <option value="Louisiana">Louisiana</option>
                                                        <option value="Maine">Maine</option>
                                                        <option value="Marshall Islands">Marshall Islands</option>
                                                        <option value="Maryland">Maryland</option>
                                                        <option value="Massachusetts">Massachusetts</option>
                                                        <option value="Michigan">Michigan</option>
                                                        <option value="Minnesota">Minnesota</option>
                                                        <option value="Mississippi">Mississippi</option>
                                                        <option value="Missouri">Missouri</option>
                                                        <option value="Montana">Montana</option>
                                                        <option value="Nebraska">Nebraska</option>
                                                        <option value="Nevada">Nevada</option>
                                                        <option value="New Hampshire">New Hampshire</option>
                                                        <option value="New Jersey">New Jersey</option>
                                                        <option value="New Mexico">New Mexico</option>
                                                        <option value="New York">New York</option>
                                                        <option value="North Carolina">North Carolina</option>
                                                        <option value="North Dakota">North Dakota</option>
                                                        <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                                                        <option value="Ohio">Ohio</option>
                                                        <option value="Oklahoma">Oklahoma</option>
                                                        <option value="Oregon">Oregon</option>
                                                        <option value="Palau">Palau</option>
                                                        <option value="Pennsylvania">Pennsylvania</option>
                                                        <option value="Puerto Rico">Puerto Rico</option>
                                                        <option value="Rhode Island">Rhode Island</option>
                                                        <option value="South Carolina">South Carolina</option>
                                                        <option value="South Dakota">South Dakota</option>
                                                        <option value="Tennessee">Tennessee</option>
                                                        <option value="Texas">Texas</option>
                                                        <option value="Utah">Utah</option>
                                                        <option value="Vermont">Vermont</option>
                                                        <option value="Virginia">Virginia</option>
                                                        <option value="Washington">Washington</option>
                                                        <option value="West Virginia">West Virginia</option>
                                                        <option value="Wisconsin">Wisconsin</option>
                                                        <option value="Wyoming">Wyoming</option>
                                                        <option value="U.S. Virgin Islands">U.S. Virgin Islands</option>
                                                        <option value="Armed Forces Americas">Armed Forces Americas</option>
                                                        <option value="Armed Forces Europe">Armed Forces Europe</option>
                                                        <option value="Armed Forces Pacific">Armed Forces Pacific</option>
                                                    </select>
                                                    <div class="arrow">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 20 20"
                                                            role="img"
                                                            class="_1fragem14 _1fragem30 _1fragem9e _1fragem9d"
                                                            focusable="false"
                                                            aria-hidden="true"
                                                        >
                                                            <path d="M0 5h20L10 15"></path>
                                                        </svg>
                                                    </div>
                                                    <span v-if="invalidFields.county" class="help-block form-error">State is a required field</span>
                                                </div>
                                                <div class="zip-code">
                                                    <input
                                                        name="postalCode"
                                                        placeholder="ZIP code"
                                                        type="text"
                                                        class="default-input"
                                                        autocomplete="postal-code"
                                                        v-model="formData.postcode"
                                                        @blur="validateFieldOnFocus"
                                                        :class="invalidFields.postcode ? 'error' : ''"
                                                        id="postcode">
                                                        <span v-if="invalidFields.postcode" class="help-block form-error">ZIP Code is a required field</span>
                                                </div>
                                            </div>
                                            <div class="phone">
                                                <input
                                                    name="phone_field"
                                                    placeholder="Phone"
                                                    type="tel"
                                                    class="default-input"
                                                    autocomplete="tel"
                                                    v-model="formData.phone"
                                                    @blur="validateFieldOnFocus"
                                                    :class="invalidFields.phone ? 'error' : ''"
                                                    id="phone">
                                                    <span v-if="invalidFields.phone" class="help-block form-error">Phone Number is a required field</span>

                                            </div>
<!--
                                            <div class="shipping-button">
                                                <a @click="goToStep1()" href="javascript:void(0)" class="cart-link">
                                                    <svg
                                                        viewBox="0 0 10 10"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        role="img"
                                                        class="_1fragem14 _1fragem30 _1fragem9e _1fragem9d"
                                                        focusable="false"
                                                        aria-hidden="true"
                                                    >
                                                        <path d="M8 1 7 0 3 4 2 5l1 1 4 4 1-1-4-4"></path>
                                                    </svg>
                                                    Return to shipping
                                                </a>
                                                <a href="javascript:void(0)" class="shipping">Continue to shipping</a>
                                            </div>
-->
                                            <div class="policy-link">
                                                <ul>
                                                    <li><a href="#">Refund policy</a></li>
                                                    <li><a href="#">Privacy policy</a></li>
                                                    <li><a href="#">Terms of service</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </div>
              </div>
            </div>

<!--
            <div class="remember-me">
              <h2>Remember me</h2>
              <div class="remember-details">
                <div class="checkbox-input">
                  <input
                    class="input-checkbox"
                    data-backup="remember_me"
                    data-remember-me-opt-in="true"
                    aria-controls="section--remember-me__phone"
                    type="checkbox"
                    value="1"
                    name="checkout[remember_me]"
                    id="checkout_remember_me"
                  />
                </div>
                <label
                  class="checkbox__label content-box__emphasis"
                  for="checkout_remember_me"
                >
                  Save my information for a faster checkout
                </label>
              </div>
            </div>

-->

            <div class="shipping-button">
              <a @click="goToStep1()" href="javascript:void(0)" class="cart-link">
                <svg
                  viewBox="0 0 10 10"
                  xmlns="http://www.w3.org/2000/svg"
                  role="img"
                  class="_1fragem14 _1fragem30 _1fragem9e _1fragem9d"
                  focusable="false"
                  aria-hidden="true"
                >
                  <path d="M8 1 7 0 3 4 2 5l1 1 4 4 1-1-4-4"></path>
                </svg>
                Return to checkout
              </a>
              <a @click="validAllFields($event)" href="javascript:void(0)" class="shipping">Pay now</a>
            </div>
            <div class="copy-right">
              <p>All rights reserved 2011-2023 Imperial Auto Services LLC</p>
            </div>
          </div>




            </div>
            <div class="right-content">
                <div v-show="cartItems.length > 0">
                <div class="accordion-text">
                    <div class="accordion-title">
                        <div class="cart-title">
                            <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" role="img" class="_1fragem14 _1fragem30 _1fragem9e _1fragem9d" focusable="false" aria-hidden="true"><path d="M17.178 13.088H5.453c-.454 0-.91-.364-.91-.818L3.727 1.818H0V0h4.544c.455 0 .91.364.91.818l.09 1.272h13.45c.274 0 .547.09.73.364.18.182.27.454.18.727l-1.817 9.18c-.09.455-.455.728-.91.728zM6.27 11.27h10.09l1.454-7.362H5.634l.637 7.362zm.092 7.715a1.817 1.817 0 1 0 .002-3.634 1.817 1.817 0 0 0-.002 3.634zm9.18 0a1.816 1.816 0 1 0-.001-3.635 1.818 1.818 0 0 0 0 3.635z"></path></svg>
                            <h2>
                                <span class="show">Show order summary</span>
                                <span class="hide">Hide order summary</span>
                                <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" role="img" class="_1fragem14 _1fragem30 _1fragem9e _1fragem9d" focusable="false" aria-hidden="true"><path d="M12.6 3 14 4.4 8.4 10 7 11.4 5.6 10 0 4.4 1.4 3 7 8.6"></path></svg>
                            </h2>
                        </div>
                        <div class="price">
                            <span>${{productsOrderTotal}}</span>
                        </div>
                    </div>
                </div>
                <div class="right-details">
                    <div v-if="step > 0" class="product-details" v-for="product in products">

                        <div class="image">
                            <img :src="product.product_image" :alt="product.info['M_TITLE']" class="shipImage"
                       :title="product.info['M_TITLE']" />
                        </div>
                        <div class="product-title">
                            <h4 v-html="product.info['M_TITLE']"></h4>
                            <small>Qty: {{ product.quantity }}</small>
                        </div>
                        <div class="price">
                            <span>${{ product.sale_price }}</span>
                            <a href="javascript:void" @click="goToStep0" class="change-btn">Change</a>
                        </div>

                    </div>
<!--
                    <div class="git-card">
                        <div class="input">
                            <input type="text" name="reductions" placeholder="Gift card or discount code">
                        </div>
                        <div class="button">
                            <a href="#">Apply</a>
                        </div>
                    </div>
-->
                    <div class="total-details">
                        <div class="subtotal">
                            <span>Subtotal</span>
                            <p>${{subTotal}}</p>
                        </div>
                        <div class="shipping">
                            <span>Shipping</span>
                            <p>${{shippingPrice}}</p>
                        </div>
                        <div class="taxes">
                            <span>Estimated taxes</span>
                            <p>{{taxPrice}}</p>
                        </div>
                    </div>
                    <div class="total">
                        <span>Total</span>
                        <p><abbr>USD</abbr> ${{productsOrderTotal}}</p>
                    </div>


                </div>
            </div>
            </div>
        </div>
    </section>
</template>

<script>

import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert);

export default {
    name: "checkoutstepa",

    data() {
        return {
          step: 1,
          billing_address: 'same',
          processing: false,
          failed: false,
          products: null,
          cartItems: null,
          taxFetched: 0,
          taxStates: {
            'North Carolina': 0.077487
          },
          formData: {
            first_name: '',
            last_name: '',
            country: 226,
            phone: '',
            add_1: '',
            add_2: '',
            town: '',
            email: '',
            email_me: false,
            postcode: '',
            county: '',
            //pass_confirmation: '',
            //pass: '',
            shipToDifferent: 0,
            needUserCreate: 0,
            shipping: 1,
            paymentType: 2,
            company:'',
            delInf: {
              first_name: '',
              last_name: '',
              add_1: '',
              add_2: '',
              town: '',
              county: '',
              country: 226,
              postcode: '',
              company: '',
              phone: '',
            },
            aim: {
              month: '',
              year: '',
              card: ''
            }
          },
          countries: {
            226: 'United States',
            173: 'Puerto Rico',
          },
          invalidFields: {},
      countries: {
        226: "United States",
        173: "Puerto Rico"
      },
      months: {
        1: '01- January',
        2: '02- February',
        3: '03- March',
        4: '04- April',
        5: '05- May',
        6: '06- June',
        7: '07- July',
        8: '08- August',
        9: '09- September',
        10: '10- October',
        11: '11- November',
        12: '12- December'
      },
      years: {
        21: '2021',
        22: '2022',
        23: '2023',
        24: '2024',
        25: '2025',
        26: '2026',
        27: '2027',
        28: '2028',
        29: '2029',
        30: '2030',
        31: '2031',
        32: '2032',
        33: '2033',
        34: '2034',
        35: '2035',
        36: '2036',
        37: '2037',
        38: '2038',
        39: '2039',
        40: '2040',
        41: '2041',
        42: '2042',
        43: '2043',
        44: '2044',
        45: '2045',
        46: '2046',
        47: '2047',
        48: '2048',
        49: '2049',
        50: '2050',
        51: '2051',
        52: '2052',
      },
        }
    },

    created() {

      localStorage.removeItem('checkoutData');
      localStorage.removeItem('shipping_price');
      localStorage.removeItem('cartTotal');


        this.cartItems = JSON.parse(localStorage.getItem('items')) || [];

        let idsList = []

        this.cartItems.forEach(item => {
          idsList.push(item.id)
        })

        axios.post('/api/products', {ids: idsList})
        .then(res => {
          this.products = res.data || []
          this.products.forEach(product => {
            this.cartItems.forEach(item => {
              if (item.id == product.id) {
                product.quantity = item.quantity
              }
            })
          })
        })
        .catch(err => {
          this.products = null
        })
    },

      watch: {
        products: {
          handler(val) {
            val.forEach(item => {
              this.cartItems.forEach(cart => {
                if (cart.id == item.id) {
                  cart.quantity = item.quantity
                }
              })
            })
          },
          deep: true
        },
        cartItems: {
          handler(val) {
            localStorage.setItem('items', JSON.stringify(val))
          },
          deep: true
        },
        'formData.delInf.country': {
          handler(val) {
            if( val != 226 && val != 173 ) {
                this.formData.delInf.country = 226;
            }
          },
          deep: true
        },

        'formData.country': {
          handler(val) {
            if( val != 226 && val != 173 ) {
                this.formData.country = 226;
            }
          },
          deep: true
        },

      },


  computed: {
    taxPrice: function () {
      if (!this.products) return 0
      if (this.taxFetched !== 0) {
        return '$' + this.taxFetched.toFixed(2)
      } else if (!this.taxStates[this.formData.delInf.county]) {
        return 'n/a'
      } else {
        let price = parseInt(this.subTotal) * this.taxStates[this.formData.delInf.county]
        return '$' + price.toFixed(2)
      }
    },
    productsOrderTotal: function () {
      if (!this.products) return 0
      let price = 0
      this.products.forEach(product => {
        price += product.sale_price * product.quantity
      })
      let shippingPrice = parseFloat(this.shippingPrice)
      price += shippingPrice;
      if (this.taxFetched !== 0) {
        price += this.taxFetched
      } else if (!this.taxStates[this.formData.delInf.county]) {
        price += 0;
      } else {
        let tax_price = parseInt(this.subTotal) * this.taxStates[this.formData.delInf.county]
        price += tax_price
      }

      var checkoutData = JSON.parse(localStorage.getItem('checkoutData')) || {};
      checkoutData.total = price.toFixed(2);
      localStorage.setItem('checkoutData', JSON.stringify(checkoutData));

      localStorage.setItem('cartTotal', price.toFixed(2) );
      return price.toFixed(2)
    },
    discountResult: function () {
      if (!this.products) return 0
      let discount = 0
      this.products.forEach(product => {
        discount += (product.price * product.quantity) - (product.sale_price * product.quantity)
      })
      return discount.toFixed(2)
    },
    shippingPrice: function () {
      if (!this.products) return 0
      let shipPrice = 0
      this.products.forEach(product => {
        let priceByItem = 0
        if (product.shipping_rate && product.shipping_rate.price_per_item) {
          priceByItem = parseFloat(product.shipping_rate.price_per_item) || 0
        } else {
          if (product.ship_by_item){
            priceByItem = parseFloat(product.ship_by_item.split(';')[0]) || 0
          }

        }
        shipPrice += priceByItem
      })
      var checkoutData = JSON.parse(localStorage.getItem('checkoutData')) || {};
      checkoutData.shipping_price = shipPrice.toFixed(2);
      localStorage.setItem('checkoutData', JSON.stringify(checkoutData));
      localStorage.setItem('shipping_price', shipPrice.toFixed(2) );
      return shipPrice.toFixed(2)
    },
    subTotal: function () {
      if (!this.products) return 0
      let subTotal = 0
      this.products.forEach(product => {
        subTotal += product.sale_price * product.quantity
      })
      return subTotal.toFixed(2)
    },
    orderedMonths: function () {
      return _.orderBy(this.months)
    },
},

  methods: {

    goToStep0(e) {
        this.step = 0;
    },

    goToStep1(e) {
        this.step = 1;
    },

    goToStep2(e) {


      let validForm = true;

      if( this.formData.email == '' ) {
        this.$set(this.invalidFields, 'email', true);
        validForm = false;
      }

      if( this.formData.delInf.first_name == '' ) {
        this.$set(this.invalidFields, 'delfirstName', true);
        validForm = false;
      }

      if( this.formData.delInf.last_name == ''  ) {
        this.$set(this.invalidFields, 'dellastName', true);
        validForm = false;
      }

      if( this.formData.delInf.add_1 == '' ) {
        this.$set(this.invalidFields, 'deladd_1', true);
        validForm = false;
      }

      if( this.formData.delInf.town == '' ) {
        this.$set(this.invalidFields, 'deltown', true);
        validForm = false;
      }

      if( this.formData.delInf.county == '' ) {
        this.$set(this.invalidFields, 'delcounty', true);
        validForm = false;
      }

      if( this.formData.delInf.country == '' ) {
        this.$set(this.invalidFields, 'delcountry', true);
        validForm = false;
      }

      if( this.formData.delInf.postcode == '' ) {
        this.$set(this.invalidFields, 'delpostcode', true);
        validForm = false;
      }

      if( this.formData.delInf.phone == '' ) {
        this.$set(this.invalidFields, 'delphone', true);
        validForm = false;
      }


      if( !validForm ) return false;

      this.step = 3;

    },

    goToStep3(e) {
        this.step = 3;
    },

    validateFieldOnFocus(e) {
      let validType = "checkEmpty"
      switch (e.target.id) {
        case 'pass':
          validType = "checkMatches"
          break;
      }
      return this[validType](e)
    },

    checkEmpty(e) {
      if (!e.target.value) {
        this.$set(this.invalidFields, e.target.id, true)
      } else {
        this.$set(this.invalidFields, e.target.id, undefined)
      }
    },

    checkMatches(e) {
      let neededField = e.target.getAttribute('data-match')
      if (!e.target.value || e.target.value !== this.formData[neededField]) {
        this.$set(this.invalidFields, e.target.id, true)
      } else {
        this.$set(this.invalidFields, e.target.id, undefined)
      }
    },

    async validAllFields(e, data = null, masterKey = null) {

      e.preventDefault();

      let validForm = true;

      if( this.formData.aim.month == '' ) {
        this.$set(this.invalidFields, 'aimMonth', true);
        validForm = false;
      }

      if( this.formData.aim.year == '' ) {
        this.$set(this.invalidFields, 'aimYear', true);
        validForm = false;
      }

      if( this.formData.aim.card == '' ) {
        this.$set(this.invalidFields, 'aimCard', true);
        validForm = false;
      }

      if( this.billing_address == 'different' ) {

        if( this.formData.first_name == '' ) {
            this.$set(this.invalidFields, 'firstName', true);
            validForm = false;
        }

        if( this.formData.last_name == '' ) {
            this.$set(this.invalidFields, 'lastName', true);
            validForm = false;
        }

        if( this.formData.phone == '' ) {
            this.$set(this.invalidFields, 'phone', true);
            validForm = false;
        }

        if( this.formData.add_1 == '' ) {
            this.$set(this.invalidFields, 'add_1', true);
            validForm = false;
        }

        if( this.formData.town == '' ) {
            this.$set(this.invalidFields, 'town', true);
            validForm = false;
        }

        if( this.formData.county == '' ) {
            this.$set(this.invalidFields, 'county', true);
            validForm = false;
        }

        if( this.formData.country == '' ) {
            this.$set(this.invalidFields, 'country', true);
            validForm = false;
        }


        if( this.formData.postcode == '' ) {
            this.$set(this.invalidFields, 'postcode', true);
            validForm = false;
        }

      }




      if( !validForm ) return false;

      return this.orderCreate();

    },

    orderCreate() {


      if(this.formData.paymentType == 5) {

        let checkoutData = {
          "first_name":this.formData.first_name,
          "last_name":this.formData.last_name,
          "country":this.formData.country,
          "phone":this.formData.phone,
          "add_1":this.formData.add_1,
          "add_2":this.formData.add_2,
          "town":this.formData.town,
          "email":this.formData.email,
          "postcode":this.formData.postcode,
          "county":this.formData.county,
          "total": this.productsOrderTotal,
          "shipping_price": this.shippingPrice,
        };
        localStorage.setItem('checkoutData', JSON.stringify(checkoutData));

        this.showAPayButton = true;

        return;

      } else if(this.formData.paymentType == 4) {

        let checkoutData = {
          "first_name":this.formData.first_name,
          "last_name":this.formData.last_name,
          "country":this.formData.country,
          "phone":this.formData.phone,
          "add_1":this.formData.add_1,
          "add_2":this.formData.add_2,
          "town":this.formData.town,
          "email":this.formData.email,
          "postcode":this.formData.postcode,
          "county":this.formData.county,
          "total": this.productsOrderTotal,
          "shipping_price": this.shippingPrice,
        };
        localStorage.setItem('checkoutData', JSON.stringify(checkoutData));

        this.showGPayButton = true;

        return;

      } else if(this.formData.paymentType == 3) {

        let checkoutData = {
          "first_name":this.formData.first_name,
          "last_name":this.formData.last_name,
          "country":this.formData.country,
          "phone":this.formData.phone,
          "add_1":this.formData.add_1,
          "add_2":this.formData.add_2,
          "town":this.formData.town,
          "email":this.formData.email,
          "postcode":this.formData.postcode,
          "county":this.formData.county,
          "total": this.productsOrderTotal,
        };
        localStorage.setItem('checkoutData', JSON.stringify(checkoutData));
        this.showVenmoButton = true;

        return;

      } else {

          this.formData['products'] = this.products

          //localStorage.setItem('formData', JSON.stringify(this.formData));

          if( this.billing_address == 'same' ) {

            this.formData.first_name = this.formData.delInf.first_name;
            this.formData.last_name = this.formData.delInf.last_name;
            this.formData.country = this.formData.delInf.country;
            this.formData.phone = this.formData.delInf.phone;
            this.formData.add_1 = this.formData.delInf.add_1;
            this.formData.add_2 = this.formData.delInf.add_2;
            this.formData.town = this.formData.delInf.town;
            this.formData.postcode = this.formData.delInf.postcode;
            this.formData.county = this.formData.delInf.county;
            this.formData.company = this.formData.delInf.company;

          }

          if(this.formData.aim && this.formData.aim.card) {
            this.formData.aim.card = this.formData.aim.card.replace(' ', '');
          }

          let submitdata = { ...this.formData, failed: this.failed }

          submitdata.state = submitdata.county;
          submitdata.delInf.state = submitdata.delInf.county;
          delete submitdata.county;
          delete submitdata.delInf.county;

          this.processing = true;

          axios.post('/api/checkout', submitdata).then(response => {

            localStorage.removeItem("items");

            if (this.formData.paymentType == 2) {
              if (response.data.error)
                this.paymentCreated = response.data;
            } else {
              setTimeout(() => {
                window.location.href = response.data.url
              }, 100)
              this.paymentCreated = response.data;
            }

            this.processing = false;

          })
          .catch(responseErrors => {
            this.failed = true

            if (responseErrors.response) {
              if (responseErrors.response.status == 422) {
                let msgHtml = 'Please complete the form fields.'
                this.$fire({
                  title: "Error",
                  html: msgHtml,
                  type: "error",
                  timer: 10000,
                });
              } else if (responseErrors.response.status == 301) {
                return location.href = responseErrors.response.data.redirect
              } else if (responseErrors.response.status == 500) {
                let avs = ('avs' in responseErrors.response.data) ? responseErrors.response.data.avs : ' ';
                let cvv = ('cvv' in responseErrors.response.data) ? responseErrors.response.data.cvv : ' ';
                let msgHtml = 'Purchase failed.<br>Try another card.';
                if (responseErrors.response.data.msg == 'A duplicate transaction has been submitted.') {
                  //window.alert('Same Error. Try again with different information');
                  msgHtml = 'Same Error.<br>Try again with different information.';
                } else if (responseErrors.response.data.msg == 'The credit card has expired.') {
                  //window.alert('Same Error. Try again with different information');
                  msgHtml = 'The credit card has expired.';
                } else if (responseErrors.response.data.msg == 'Credit card expiration date is invalid.') {
                  //window.alert('Same Error. Try again with different information');
                  msgHtml = 'The card expiration date entered does not match the debit/credit card provided.';
                } else if (['E'].includes(avs)) {
                  //window.alert('AVS data provided is invalid or AVS is not allowed for the card type that was used.');
                  msgHtml = 'AVS data provided is invalid or AVS is not allowed for the card type that was used.';
                } else if (['R'].includes(avs)) {
                  //window.alert('The AVS system was unavailable at the time of processing.')
                  msgHtml = 'The AVS system was unavailable at the time of processing.';

                } else if (['G'].includes(avs)) {
                  //window.alert('The card issuing bank is of non-U.S. origin and does not support AVS.')
                  msgHtml = 'The card issuing bank is of non-U.S. origin and does not support AVS.'

                } else if (['U'].includes(avs)) {
                  //window.alert('The address information for the cardholder is unavailable.')
                  msgHtml = 'The address information for the cardholder is unavailable.'

                } else if (['S'].includes(avs)) {
                  //window.alert('The U.S. card issuing bank does not support AVS.')
                  msgHtml = 'The U.S. card issuing bank does not support AVS.'

                } else if (['N'].includes(avs)) {
                  //window.alert('Address: No Match. ZIP Code: No Match.')
                  msgHtml = 'The billing address entered does not match the debit/credit card provided.<br>The zip code entered does not match the debit/credit card provided.'

                } else if (['A'].includes(avs)) {
                  //window.alert('Address: Match. ZIP Code: No Match.')
                  msgHtml = 'The zip code entered does not match the debit/credit card provided.'

                } else if (['Z'].includes(avs)) {
                  //window.alert('Address: No Match. ZIP Code: Match.')
                  msgHtml = 'The billing address entered does not match the debit/credit card provided.'

                } else if (['W'].includes(avs)) {
                  //window.alert('Address: No Match. ZIP Code: Matched 9 digits.')
                  msgHtml = 'The billing address entered does not match the debit/credit card provided.'

                } else if (['X'].includes(avs)) {
                  //window.alert('Address: Match. ZIP Code: Matched 9 digits.')
                  msgHtml = 'Purchase failed.<br>Try another card.'

                } else if (responseErrors.response.data.msg == 'The credit card number is invalid.') {
                  //window.alert('The credit card number is invalid. Try again with different card.');
                  msgHtml = 'The credit card number is invalid.<br>Try again with different card.'

                } else if ([' ', 'P'].includes(avs)) {
                  //window.alert('Purchase failed. Try another card.');
                  msgHtml = 'Purchase failed.<br>Try another card.'

                } else if (cvv != ' ') {

                  if( ['N', 'P', 'S', 'U'].includes(cvv) ) {
                    //window.alert('The credit card number is invalid. Try again with different card.');
                    msgHtml = 'The card security code (CVV) entered does not match the debit/credit card provided.'
                  }

                } else {
                  //window.alert('Purchase failed. Try another card.');
                  msgHtml = 'Purchase failed.<br>Try another card.'
                }

                this.$fire({
                  title: "Error",
                  html: msgHtml,
                  type: "error",
                  timer: 10000,
                });
              }
            }

            this.processing = false;

          })





      }



    },

    updateProduct(e, product, quantity) {
      this.products.forEach((item, key) => {
        if (item.id == product.id) {
          item.quantity = quantity
          if (!item.quantity || item.quantity === "0") {
            this.products.splice(key, 1)
            this.cartItems.forEach((cartItem, k) => {
              if (cartItem.id == product.id) {
                this.cartItems.splice(k, 1)
              }
            })
            // this.$delete(this.product, key)
          } else {
            this.$set(this.products, key, item)
          }
        }
      })
    },


    quantityDown(e, product) {

//console.log('quantityDown()');

        this.updateProduct(e, product, parseInt(product.quantity) - 1);


    },

    quantityUp(e, product) {

//console.log('quantityUp()');

        this.updateProduct(e, product, parseInt(product.quantity) + 1);

    },

    removeItem(e, product) {

//console.log('removeitem()');

        this.updateProduct(e, product, 0);

    },



  },


}
</script>





